export enum ApiStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  FAILED = 'failed',
  SUCCEEDED = 'succeeded',
  NOT_CALLED = 'not_called',
}
